import React from 'react';
import { connect } from 'react-redux';
import { filterQueryChanged } from 'manage-modules/redux/manageModulesActions';
import InputWhite from 'components/InputWhite';

const ModulesSearchInput = ({ filterQuery, onChange }) =>
  <InputWhite
    type="text"
    label="begin typing..."
    name="search"
    value={filterQuery}
    onChange={onChange}
  />;

const mapStateToProps = state => ({
  filterQuery: state.manageModules.modulesDrawer.filterQuery,
});

const mapDispatchToProps = dispatch => ({
  onChange: value => {
    dispatch(filterQueryChanged(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModulesSearchInput);
